import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUpdatedOrderInfo } from "../../Utilities";
import {
    updateExchangeSettingsDetails,
    updateRefundSettingsDetails,
    setProductDetails,
    updateOtherSettings,
    updatePaymentSettings,
} from "../../redux/slices";
import {
    exchangeSettingsActionTypes,
    refundSettingsActionTypes,
    productActionTypes,
    otherSettingsActionTypes,
    paymentSettingTypes,
} from "../../redux/utils";
import { useHardCode, useAPI } from "../../hooks";
import { useAppContext } from "../../contexts";
import { Toast } from "..";
export const CashFree = ({
    cashfree_session_id,
    cashfree_reference_id,
    collectPaymentThrough,
    store_name,
    route_name,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoader, setIsLoader] = useState(false);
    const refundSettingsState = useSelector((state) => state.refundSettings);
    const storeConfigState = useSelector((state) => state.storeSettings);
    const productDetailsState = useSelector((state) => state.productDetails);
    const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
    const otherSettingsState = useSelector((state) => state.otherSettings);
    const paymentSettingsState = useSelector((state) => state.paymentSettings);
    const selectedProductDetailsState = useSelector(
        (state) => state.selectedProductDetails
    );
    const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME } = useHardCode();
    const {
        SUBMIT_RETURN_REQUEST_API,
        RETURN_SUBMIT_API,
        EXCHANGE_RAZORPAY_PAYMENT_API,
    } = useAPI();
    const {
        isInternalServerError,
        setIsInternalServerError,
        setIsPaymentCompleted,
        setIsLoadingPayment,
        setRazorPayPaymentSuccess,
    } = useAppContext();

    const FINAL_API_CALL_RETURN =
        storeConfigState.platform === "shopify"
            ? SUBMIT_RETURN_REQUEST_API
            : RETURN_SUBMIT_API;

    const FINAL_API_CALL_EXCHANGE =
        storeConfigState.platform === "shopify"
            ? EXCHANGE_RAZORPAY_PAYMENT_API
            : EXCHANGE_SUBMIT_API;

    const openPayModal = (cashfree_session_id, cashfree_reference_id) => {
        const cashfree = Cashfree({
            mode: "production",
        });
        let checkoutOptions = {
            paymentSessionId: cashfree_session_id,
            redirectTarget: "_modal",
        };
        cashfree.checkout(checkoutOptions).then((result) => {
            console.log(result);
            if (result.error) {
                console.log(
                    "User has closed the popup or there is some payment error, Check for Payment Status"
                );
                console.log(result.error);
                setIsInternalServerError(true);
            }
            if (result.redirect) {
                console.log("Payment will be redirected");
            }
            if (result.paymentDetails) {
                console.log("Payment has been completed, Check for Payment Status");
                console.log(result.paymentDetails.paymentMessage);
                if (route_name === "return") {
                    (async () => {
                        setIsLoader(true);
                        if (
                            refundSettingsState.refundReviewRoute === "STORE_CREDIT" ||
                            refundSettingsState.refundReviewRoute === "ORIGINAL_PAYMENT"
                        ) {
                            const maxRetries = 3;
                            let delayTime = 1000; //time in ms
                            const delay = (ms) =>
                                new Promise((resolve) => setTimeout(resolve, ms));
                            for (let attempt = 0; attempt < maxRetries; attempt++) {
                                try {
                                    const response = await axios.post(FINAL_API_CALL_EXCHANGE, {
                                        ran: otherSettingsState.ran,
                                        razorpay_payment_id: cashfree_reference_id,
                                        collect_payment_through : collectPaymentThrough,
                                        store_name: storeConfigState.storeUniqueID,
                                        id: paymentSettingsState.paymentID,
                                        amount: refundSettingsState.razorPayObject.payment_amount,
                                      });
                        
                                      if (response) {
                                        dispatch(
                                          updatePaymentSettings({
                                            key: paymentSettingTypes.UPDATE_PAYMENT_REQUIRED,
                                            value: false,
                                          })
                                        );
                                        dispatch(
                                          updateRefundSettingsDetails({
                                            key: refundSettingsActionTypes.UPDATE_COLLECT_FROM_RAZORPAY,
                                            value: false,
                                          })
                                        );
                                        setRazorPayPaymentSuccess(true);
                                        setIsLoadingPayment(false);
                                        setIsPaymentCompleted(true);
                                        const isShowRAN =
                                            SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.steve_maiden
                                                ? ""
                                                : `RAN# ${otherSettingsState.ran}`;
                                        if (
                                            refundSettingsState.refundReviewRoute ===
                                            "ORIGINAL_PAYMENT"
                                        ) {
                                            dispatch(
                                                updateRefundSettingsDetails({
                                                    key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
                                                    value: storeConfigState?.themeConfig
                                                        ?.return_submission_original_payment_left_content
                                                        ? storeConfigState?.themeConfig
                                                            ?.return_submission_original_payment_left_content
                                                        : `${storeConfigState?.themeConfig?.your_return_request} ${isShowRAN} ${storeConfigState?.themeConfig?.has_been_submitted_original_payment_method}`,
                                                })
                                            );
                                        } else if (
                                            refundSettingsState.refundReviewRoute === "STORE_CREDIT"
                                        ) {
                                            dispatch(
                                                updateRefundSettingsDetails({
                                                    key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
                                                    value:
                                                        storeConfigState?.themeConfig
                                                            ?.return_submission_store_credit_left_title,
                                                })
                                            );

                                            dispatch(
                                                updateRefundSettingsDetails({
                                                    key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
                                                    value: storeConfigState?.themeConfig
                                                        ?.return_submission_store_credit_left_content
                                                        ? storeConfigState?.themeConfig
                                                            ?.return_submission_store_credit_left_content
                                                        : `${storeConfigState?.themeConfig?.your_return_request} ${isShowRAN} ${storeConfigState?.themeConfig?.has_been_submitted_original_payment_method}`,
                                                })
                                            );

                                            dispatch(
                                                updateRefundSettingsDetails({
                                                    key: refundSettingsActionTypes.UPDATE_THANKYOU_CARD_HEADING,
                                                    value:
                                                        storeConfigState?.themeConfig
                                                            ?.return_submission_store_credit_right_card_title,
                                                })
                                            );

                                            dispatch(
                                                updateRefundSettingsDetails({
                                                    key: refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION,
                                                    value:
                                                        storeConfigState?.themeConfig
                                                            ?.return_submission_store_credit_right_card_subtitle,
                                                })
                                            );
                                        }

                                        // Update product list
                                        const updatedOrderInfo = getUpdatedOrderInfo(
                                            productDetailsState,
                                            selectedProductDetailsState
                                        );

                                        // Update the product list on Redux
                                        dispatch(
                                            setProductDetails({
                                                key: productActionTypes.SET_ORDER_INFO,
                                                value: updatedOrderInfo,
                                            })
                                        );
                                        setIsLoader(false);
                                        navigate("/ThankYou");
                                        break;
                                    }
                                } catch (error) {
                                    // If it's the last attempt, rethrow the error
                                    if (attempt === maxRetries - 1) {
                                        if (error?.response?.status === 500) {
                                            setIsLoader(false);
                                            setIsInternalServerError(true);
                                        }
                                        console.log("Reached maximum retries.");
                                    } else {
                                        // Wait for the delay time before retrying
                                        await delay(delayTime);
                                        delayTime += 1000;
                                    }
                                }
                            }
                        } else if (refundReturnID === "3") {
                            navigate("/RefundOptions");
                            dispatch(
                                updateExchangeSettingsDetails({
                                    key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_BACK,
                                    value: "/refund",
                                })
                            );
                        }
                    })();
                } else if (route_name === "exchange") {
                    (async () => {
                        setIsLoader(true);
                        const maxRetries = 3;
                        let delayTime = 1000; //time in ms
                        const delay = (ms) =>
                            new Promise((resolve) => setTimeout(resolve, ms));
                        for (let attempt = 0; attempt < maxRetries; attempt++) {
                            try {
                                const response = await axios.post(FINAL_API_CALL_EXCHANGE, {
                                    ran: otherSettingsState.ran,
                                    razorpay_payment_id: cashfree_reference_id,
                                    collect_payment_through:collectPaymentThrough,
                                    store_name: storeConfigState.storeUniqueID,
                                    id: paymentSettingsState.paymentID,
                                    amount: refundSettingsState.razorPayObject.payment_amount,
                                });

                                if (response) {
                                    dispatch(
                                        updatePaymentSettings({
                                            key: paymentSettingTypes.UPDATE_PAYMENT_REQUIRED,
                                            value: false,
                                        })
                                    );
                                    dispatch(
                                        updateRefundSettingsDetails({
                                            key: refundSettingsActionTypes.UPDATE_COLLECT_FROM_RAZORPAY,
                                            value: false,
                                        })
                                    );
                                    dispatch(
                                        updateRefundSettingsDetails({
                                            key: refundSettingsActionTypes.UPDATE_COLLECT_PAYMENT_THROUGH,
                                            value: false,
                                        })
                                    );
                                    setRazorPayPaymentSuccess(true);
                                    setIsLoadingPayment(false);
                                    setIsPaymentCompleted(true);
                                }
                                break;
                            } catch (error) {
                                // If it's the last attempt, rethrow the error
                                setIsLoader(false);
                                if (attempt === maxRetries - 1) {
                                    if (error?.response?.status === 500) {
                                        setIsInternalServerError(true);
                                    }
                                    console.log("Reached maximum retries.");
                                } else {
                                    // Wait for the delay time before retrying
                                    await delay(delayTime);
                                    delayTime += 1000;
                                }
                            }
                        }
                    })();
                }
            }
        });
    };
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <>
            {isInternalServerError ? (
                <Toast type="error" />
            ) : (
                <button
                    className="saara_custom_btn btn__submit"
                    style={{ marginLeft: "10px" }}
                    onClick={() =>
                        openPayModal(cashfree_session_id, cashfree_reference_id)
                    }
                >
                    {isLoader ? (
                        <div
                            className="saara-spinner-border saara-spinner-border-sm"
                            role="status"
                        >
                            <span className="saara-visually-hidden"></span>
                        </div>
                    ) : (
                        storeConfigState?.themeConfig
                            ?.exchange_payment_page_pay_now_button_label
                    )}
                </button>
            )}
        </>
    );
};
